import {
    GTMEventPromotionData,
    PromotionClickAnalyticsEvent,
} from "@hermes/fragments/analytics";

interface PromotionClickShopLocatorModel {
    store: { name: string; position: number };
}

/**
 * This class is used for describe events concerning the Store Locator.
 */
export class PromotionClickShopLocatorEvent extends PromotionClickAnalyticsEvent {
    public override eventData!: PromotionClickShopLocatorModel;

    constructor(eventData: PromotionClickShopLocatorModel) {
        super(eventData);
    }

    /**
     * Overload formatForGTM of inherited class
     * Return formatter for eventaction and eventlabel key
     */
    public override formatForGTM(): GTMEventPromotionData {
        /* Construct promotions */
        const promotions = {
            name: "Store locator search results",
            id: "",
            creative: "",
            position: `${this.eventData.store.name}::${this.eventData.store.position}`,
        };

        return {
            ...super.formatForGTM(),
            ecommerce: {
                promoClick: {
                    promotions: [promotions],
                },
            },
        };
    }
}
